export const GET_CHAPTERS = 'GET_CHAPTERS';
export const GET_CHAPTER = 'GET_CHAPTER';
export const GET_ARTISTS = 'GET_ARTISTS';

